import * as Sentry from "@sentry/react";

const isProduction = process.env.REACT_APP_ENV === "production";

Sentry.init({
  dsn: "https://a2b370a570775dff5d6bd3f2ee12fa6a@o4509755819294720.ingest.us.sentry.io/4511737816416256",
  enabled: isProduction,
  environment: process.env.REACT_APP_ENV,

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  sendDefaultPii: true,
  tracesSampleRate: isProduction ? 0.3 : 0,
  tracePropagationTargets: ["localhost", /^https:\/\/api\.pillup\.in/],

  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});
